module.exports = __webpack_public_path__ + "img/control-2.f2fdc388.png";